export default "__VITE_ASSET__BRzJN_vM__"